import { Box, Skeleton } from '@mui/material';
import DetectMobileHelper from '../../../helpers/detect-mobile.helper';

const TipCard = () => {
  return <>
    {DetectMobileHelper.isMobile() ?
      <Box className='article-card-ghost light-boxed d-flex flex-column mb-3' >
        <Box className='d-flex flex-column w-100 h-50' >
          <Skeleton className='mx-2' width='95%' height='100%' animation='wave' />
          <Skeleton className='my-1 mx-2' width='95%' height='20%' animation='wave' />
        </Box>
      </Box>
      :
      <Box className='article-card-ghost light-boxed d-flex flex-row mb-3' >
        <Box className='d-flex flex-column w-100 h-100' >
          <Skeleton className='mx-2' width='98%' height='80%' animation='wave' />
          <Skeleton className='mx-2' width='98%' height='20%' animation='wave' />
        </Box>
      </Box>
    }
  </>;
}

export default TipCard;
